import { InjectionToken } from '@angular/core';
import { FilterEngineSettings } from './models';

export const FILTER_ENGINE_SETTINGS = new InjectionToken<FilterEngineSettings>('FILTER_ENGINE_SETTINGS');
